export const appPaneNames = [
    'help',
    'tips',
    'support',
    'feedback',
    'getDiagnostics',
    'rolloutOverrides',
    'editor',
    'dictationHelp',
    'addins',
    'chatCopilot',
] as const;

export type AppPaneName = typeof appPaneNames[number];
